"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPartnerIconProperty = exports.partnerIconPropertyDefinition = void 0;
exports.partnerIconPropertyDefinition = {
    view: {
        label: 'Partner Icon',
        hint: 'Image used to display the partner icon across our platforms. Best practice is to add a 1x1 aspect ratio image.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['image'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'partner-icon',
};
const isPartnerIconProperty = (prop) => {
    return prop.name === exports.partnerIconPropertyDefinition.name;
};
exports.isPartnerIconProperty = isPartnerIconProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydG5lci1pY29uLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcGFydG5lci1pY29uLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGNBQWM7UUFDckIsSUFBSSxFQUFFLGdIQUFnSDtLQUN2SDtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsT0FBTyxDQUFDO1NBQ3BCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLGNBQWM7Q0FDVyxDQUFBO0FBSTFCLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxJQUFrQixFQUErQixFQUFFO0lBQ3ZGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxxQ0FBNkIsQ0FBQyxJQUFJLENBQUE7QUFDekQsQ0FBQyxDQUFBO0FBRlksUUFBQSxxQkFBcUIseUJBRWpDIn0=